export default Object.freeze({
  LoadFile: 1,
});
